<template>
  <div class="oppoprTunity">
    <headers class="herderNav" ref="header" :isChange="false" />

    <div class="oppoprTunityCon">
      <div class="suspension">
        <div class="oppoprTunityConLeft">
          <el-row class="tac">
            <el-col :span="24">
              <h2 class="tits">关于机经</h2>
              <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
                text-color="#3c3c3c" active-text-color="#5B7CFF" :unique-opened="true" router>
                <el-menu-item :index="'/saomang'"><span slot="title">机经扫盲</span></el-menu-item>
                <el-menu-item :index="'/tongji'"><span slot="title">换库统计</span></el-menu-item>
                <el-submenu index="1">
                  <template slot="title"><span>机经下载</span></template>
                  <el-menu-item-group>
                    <el-menu-item :index="'/freeDown'">免费版</el-menu-item>
                    <el-menu-item :index="'/down'">学员专享版</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
          <div class="codeDown" style="">
            <img :src="num==1?require('@/assets/bottom/oneCode.png'):require('@/assets/bottom/twoCode.png')"
              @load="cut" />
            <div>
              <p>扫码添加小助手微信，</p>
              <p> 获取最新机经 </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="oppoprTunityConRight">
        <!-- 公共部分 -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import headers from '../../components/header.vue'
  import searchNav from '../../components/searchNav.vue'
  export default {
    components: {
      searchNav,
      headers
    },
    mounted() {
      this.$refs.header.isTop = false
      this.$refs.header.headerBack.background = '#ffffff';
      this.$refs.header.herderTits.color = '#666666';
      this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
      this.$refs.header.loginButton = {
        background: '#618aff',
        color: '#fff'
      }
      this.$refs.header.phoneButton = {
        color: '#618aff',
        border: '1px solid #618aff'
      }
      // api.baseParams().then(res => {
      //   console.log(res)
      // })
    },
    data() {
      return {
        navCodes: require('../../assets/login/navCode.png'),
        headerIcon: require('@/assets/bottom/bottomIcon.png'),
        num: 0
      }
    },
    methods: {
      goSearch() {
        this.$router.push("/searchMatter")
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      cut() {
        setTimeout(() => {
          if (this.num == 0) {
            this.num = 1;
          } else {
            this.num = 0;
          }
        }, 500)

      }

    }
  }
</script>

<style scoped>
  @import '../../assets/css/opportunity.css';
</style>



// WEBPACK FOOTER //
// src/view/opporTunity/opportunity.vue